export default {
  en: {
    abilities: "Abilities",
    ability: "Ability",
    id: "ID",
    name: "Name",
    description: "Description",
    technique: "Technique",
    techniqueId: "Technique ID",
    techniqueName: "Technique Name",
    platform: "Platform",
    tactic: "Tactic",
    executor: "Executor",
    command: "Command",
    usedFact: "Used Fact | Used Facts",
    favorites: "Show only favorites",
    executions: "Executions",
    searchResults:
      "Your search resulted in <strong>{in}</strong> out of <strong>{outOf}</strong> abilities",
    searchResultsTotal:
      "Your search resulted in <strong>{outOf}</strong> abilities",
    hasRequirementsTitle: "Requirement",
    hasRequirements: "This ability has requirement:",
    unlocksOtherAbilitiesTitle: "Unlock",
    unlocksOtherAbilities: "This ability unlocks other abilities:",
    usesPayloadTitle: "Payload",
    usesPayload: "This ability uses a payload",
    canCleanupTitle: "Cleanup",
    canCleanup: "This ability can clean itself up",
    noCleanup: "NO Cleanup Command",
    allTechniques: "Techniques",
    allTechniquesIDs: "Techniques IDs",
    allTactics: "Tactics",
    resetFilters: "Reset filters",
    breadcrumbDetails: "Details",
    abilityDescription:
      "The abilities are composed of the tactics and techniques from the MITRE table (ATT&CK) and will be executed through agents who will perform actions to check the security posture, identifying vulnerabilities and how to fix them.",
    techniqueDescription:
      "The ATT&CK structure is made up of 14 tactics and in each one of them we have a series of techniques that are used by malware or threat groups to carry out compromise actions, made up of a sequence of activities employed to complete the attacker's mission.",
    executorsDescription:
      "These are executable files that can be attached inside the agent to try to perform a damaging action, thus we can identify possible vulnerabilities and promote preventive actions in the environments. They can consist of exe type files, a code, or a powershell script.",
    create: {
      breadcrumb: "Create a New Ability",
      create: "Create Ability",
      form: {
        requester: {
          title: "Requester Profile",
          subtitle:
            "Indicates the characteristics and attributions linked to the profile of the user who is requesting the creation of the ability within the platform.",
          nameLabel: "Creator Name",
          profileLabel: "Creator Profile",
          objectiveLabel: "Objective",
          objectivePlaceholder:
            "Explain why this ability was created and what is it’s goal"
        },
        ability: {
          title: "Ability",
          subtitle:
            "A ability is a specific implementation of a Mitre ATT&CK tactic/technique that can be executed on agents deployed in an environment. Abilities will include the commands to be executed, the platforms/executors on which the commands can be executed (e.g. Windows/PowerShell).",
          idLabel: "ID",
          nameLabel: "Name",
          namePlaceholder: "Name your ability",
          descriptionLabel: "Description",
          descriptionPlaceholder: "Describe your ability function"
        },
        technique: {
          title: "Technique",
          subtitle:
            "They are specific categories and actions used by attackers to achieve their objectives in a cyber attack. Techniques represent the specific actions taken to achieve these objectives.",
          tacticLabel: "Tactic",
          tacticPlaceholder: "Select a tactic",
          techniqueIdLabel: "Technique ID",
          techniqueIdPlaceholder: "Select the technique ID",
          techniqueNameLabel: "Technique Name"
        },
        executors: {
          title: "Executors",
          subtitle:
            "For each platform there is a list of executors. In the standard Sandcat deployment, the Darwin and Linux platforms can use sh and Windows can use psh (PowerShell) or cmd (command prompt). Each platform block consists of: command; payload; uploads; cleanup; parsers; requirements; and timeout.",
          platformLabel: "Platform",
          parserLabel: "Parser",
          parserLogLabel: "Parser Log",
          parserLogPlaceholder: "Select an option",
          parserSourceLabel: "Parser Source",
          parserPlaceholder:
            "Enter the values separated by commas. Example: host.screenshot.png,host.chrome.bookmark_title,parser.teste",
          prerequisiteLabel: "Operating system prerequisite",
          notPrerequisiteLabel: "There is no operating system prerequisite",
          prerequisiteLabelCommand: "Command prerequisite",
          notPrerequisiteLabelCommand: "There is no command prerequisite",
          prerequisitePlaceholder: "Write what your ability requires to work",
          requiredPrivilegeLabel: "Required Privilege",
          executeLabel: "Executor",
          notExecuteLabel: "There is no executor",
          payloadLabel: "Payload",
          notPayloadLabel: "There is no payload",
          addPayload: "Add Payload",
          commandLabel: "Command",
          notCommandLabel: "There is no command",
          commandPlaceholder: "Command",
          cleanupCommandLabel: "Cleanup Command",
          cleanupCommandPlaceholder: "Cleanup Command",
          addCleanupCommandButton: "Add Cleanup Command",
          timeoutLabel: "Timeout"
        }
      },
      modal: {
        title: "Save Ability?",
        text: "Are you sure that you want to save this ability?"
      }
    },
    abilityOfficial: "Official",
    abilityCreated: "Created",
    requesterProfileTitle: "Requester Profile",
    requesterProfileDescription:
      "Here the requestor profile is registered to determine the access mode that is being created, that is, which RaidStorm features this profile can have access to.",
    creatorName: "Creator Name",
    creatorProfile: "Creator Profile",
    creatorObjective: "Objective",
    requiredPrivilegeUser: "User",
    requiredPrivilegeElevated: "Elevated"
  },
  pt: {
    abilities: "Habilidades",
    ability: "Habilidade",
    id: "ID",
    name: "Nome",
    description: "Descrição",
    technique: "Técnica",
    techniqueId: "ID da Técnica",
    techniqueName: "Nome da Técnica",
    platform: "Plataforma",
    tactic: "Tática",
    executor: "Executor",
    command: "Comando",
    usedFact: "Fact usado | Facts usados",
    favorites: "Mostrar apenas os favoritos",
    executions: "Execuções",
    searchResults:
      "Sua busca resultou em <strong>{in}</strong> de <strong>{outOf}</strong> habilidades",
    searchResultsTotal:
      "Sua busca resultou em <strong>{outOf}</strong> habilidades",
    hasRequirementsTitle: "Requisito",
    hasRequirements: "Esta habilidade possui requisito:",
    unlocksOtherAbilitiesTitle: "Desbloquear",
    unlocksOtherAbilities: "Esta habilidade desbloqueia outras habilidades:",
    usesPayloadTitle: "Payload",
    usesPayload: "Esta habilidade usa um payload",
    canCleanupTitle: "Cleanup",
    canCleanup: "Esta habilidade pode limpar-se a si mesma",
    noCleanup: "Não existe comando de Cleanup",
    allTechniques: "Técnicas",
    allTechniquesIDs: "Técnicas IDs",
    allTactics: "Táticas",
    resetFilters: "Limpar filtros",
    breadcrumbDetails: "Detalhes",
    abilityDescription:
      "As habilidades são compostas pelas táticas e técnicas da tabela MITRE (ATT&CK) e serão executadas através de agentes que irão realizar ações para verificar a postura de segurança, identificando vulnerabilidades e como corrigi-las.",
    techniqueDescription:
      "A estrutura ATT&CK é formada por 14 táticas e em cada uma delas temos uma série de técnicas que são usadas por malware ou grupos de ameaças para realizara ações de comprometimento, formada por uma sequência de atividades empregadas para concluir a missão do invasor.",
    executorsDescription:
      "São arquivos executáveis que pode ser anexado dentro do agente para tentar realizar uma ação danosa, assim podemos identificar possíveis vulnerabilidades e promover ações preventivas nos ambientes. Eles podem ser constituídos arquivos do tipo exe, um código, ou um script em powershell.",
    create: {
      breadcrumb: "Criar uma Nova Habilidade",
      create: "Criar Habilidade",
      form: {
        requester: {
          title: "Perfil do Solicitante",
          subtitle:
            "Indica as características e atribuições atreladas ao perfil do usuário que está solicitando a criação da habilidade dentro da plataforma.",
          nameLabel: "Nome do Criador",
          profileLabel: "Perfil do Criador",
          objectiveLabel: "Objetivo",
          objectivePlaceholder:
            "Explique por que essa habilidade foi criada e qual é o seu objetivo"
        },
        ability: {
          title: "Habilidade",
          subtitle:
            "Uma habilidade é uma implementação específica de tática/técnica do Mitre ATT&CK que pode ser executada em agentes implantados em um ambiente. As habilidades incluirão os comandos a serem executados, as plataformas/executores em que os comandos podem ser executados (ex: Windows/PowerShell).",
          idLabel: "ID",
          nameLabel: "Nome da Habilidade",
          namePlaceholder: "Dê um nome à sua Habilidade",
          descriptionLabel: "Descrição",
          descriptionPlaceholder: "Descreva a função de sua Habilidade"
        },
        technique: {
          title: "Técnica",
          subtitle:
            "São categorias e ações específicas utilizadas pelos atacantes para atingir seus objetivos em um ataque cibernético. As técnicas representam as ações específicas tomadas para atingir esses objetivos.",
          tacticLabel: "Tática",
          tacticPlaceholder: "Selecione uma Tática",
          techniqueIdLabel: "ID da Técnica",
          techniqueIdPlaceholder: "Selecione a ID da Técnica",
          techniqueNameLabel: "Nome da Técnica"
        },
        executors: {
          title: "Executores",
          subtitle:
            "Para cada plataforma há uma lista de executores. Na implantação padrão do Sandcat, as plataformas Darwin e Linux podem usar sh e o Windows pode usar psh (PowerShell) ou cmd (prompt de comando). Cada bloco de plataforma consiste em: command; payload; uploads; cleanup; parsers; requirements; e timeout.",
          platformLabel: "Plataforma",
          parserLabel: "Parser",
          parserLogLabel: "Parser Log",
          parserLogPlaceholder: "Selecione uma opção",
          parserSourceLabel: "Parser Source",
          parserPlaceholder:
            "Insira os valores separados por vírgula. Ex.: host.screenshot.png,host.chrome.bookmark_title,parser.teste",
          prerequisiteLabel: "Pré-requisito do Sistema Operacional",
          notPrerequisiteLabel:
            "Não existe pré-requisito do sistema operacional",
          prerequisiteLabelCommand: "Pré-requisito de Comando",
          notPrerequisiteLabelCommand: "Não existe pré-requisito de comando",
          prerequisitePlaceholder:
            "Escreva o que sua Habilidade exige para funcionar",
          requiredPrivilegeLabel: "Requer Privilégio",
          executeLabel: "Executor",
          notExecuteLabel: "Não existe executor",
          payloadLabel: "Payload",
          notPayloadLabel: "Não existe payload",
          addPayload: "Adicionar Payload",
          commandLabel: "Comando",
          notCommandLabel: "Não existe comando",
          commandPlaceholder: "Comando",
          cleanupCommandLabel: "Comando de Cleanup",
          cleanupCommandPlaceholder: "Comando de Cleanup",
          addCleanupCommandButton: "Adicionar Comando Cleanup",
          timeoutLabel: "Tempo Limite"
        }
      },
      modal: {
        title: "Salvar Habilidade?",
        text: "Tem certeza de que deseja salvar essa Habilidade?"
      }
    },
    abilityOfficial: "Oficial",
    abilityCreated: "Criada",
    requesterProfileTitle: "Perfil do Solicitante",
    requesterProfileDescription:
      "Aqui se realiza o cadastro do perfil de solicitante para determinar o modo de acesso que está sendo criado, ou seja,  quais são as features do RaidStorm que este perfil poderá ter acesso.",
    creatorName: "Nome do Criador",
    creatorProfile: "Perfil do Criador",
    creatorObjective: "Objetivo",
    requiredPrivilegeUser: "Usuário",
    requiredPrivilegeElevated: "Elevado"
  },
  es: {
    abilities: "Habilidades",
    ability: "Habilidade",
    id: "ID",
    name: "Nombre",
    description: "Descripción",
    technique: "Técnica",
    techniqueId: "ID da Técnica",
    techniqueName: "Nombre de la Técnica",
    platform: "Plataforma",
    tactic: "Táctica",
    executor: "Ejecutor",
    command: "Comando",
    usedFact: "Fact usado | Facts usados",
    favorites: "Mostrar solo favoritos",
    executions: "Ejecuciones",
    searchResults:
      "Su búsqueda ha resultado en <strong>{in}</strong> de <strong>{outOf}</strong> habilidades",
    searchResultsTotal:
      "Su búsqueda ha dado como resultado <strong>{outOf}</strong> habilidades",
    hasRequirementsTitle: "Requisito",
    hasRequirements: "Esta habilidad tiene requisito:",
    unlocksOtherAbilitiesTitle: "Desbloquea",
    unlocksOtherAbilities: "Esta habilidad desbloquea otras habilidades:",
    usesPayload: "Esta habilidad utiliza un payload",
    canCleanupTitle: "Cleanup",
    canCleanup: "Esta habilidad puede limpiarse a sí misma",
    noCleanup: "NO Comando de limpieza",
    allTechniques: "Técnicas",
    allTechniquesIDs: "Técnicas IDs",
    allTactics: "Tácticas",
    resetFilters: "Restablecer filtros",
    breadcrumbDetails: "Detalles",
    abilityDescription:
      "Las habilidades se componen de las tácticas y técnicas de la tabla MITRE (ATT&CK) y se ejecutarán a través de agentes que realizarán acciones para verificar la postura de seguridad, identificando las vulnerabilidades y cómo corregirlas.",
    techniqueDescription:
      "La estructura de ATT&CK se compone de 14 tácticas y en cada una de ellas tenemos una serie de técnicas que son utilizadas por el malware o grupos de amenazas para llevar a cabo acciones de compromiso, compuestas por una secuencia de actividades empleadas para completar la misión del atacante.",
    executorsDescription:
      "Se trata de archivos ejecutables que pueden ser adjuntados dentro del agente para intentar realizar una acción perjudicial, de esta forma podemos identificar posibles vulnerabilidades y promover acciones preventivas en los entornos. Pueden consistir en archivos de tipo exe, un código o un script de powershell.",
    create: {
      breadcrumb: "Crear una nueva Habilidad",
      create: "Crear Habilidad",
      form: {
        requester: {
          title: "Perfil del Solicitante",
          subtitle:
            "Indica las características y atribuciones vinculadas al perfil del usuario que solicita la creación de la skill dentro de la plataforma.",
          nameLabel: "Nombre del Creador",
          profileLabel: "Perfil del Creador",
          objectiveLabel: "Objetivo",
          objectivePlaceholder:
            "Explica por qué se creó esta Habilidad y cuál es su objetivo"
        },
        ability: {
          title: "Habilidad",
          subtitle:
            "Una habilidad es una implementación específica de una táctica/técnica Mitre ATT&CK que puede ejecutarse en agentes desplegados en un entorno. Las habilidades incluirán los comandos a ejecutar, las plataformas/ejecutores en los que se pueden ejecutar los comandos (por ejemplo, Windows/PowerShell).",
          idLabel: "ID",
          nameLabel: "Nombre",
          namePlaceholder: "Nombra tu Habilidad",
          descriptionLabel: "Descripción",
          descriptionPlaceholder: "Describe la función de tu Habilidad"
        },
        technique: {
          title: "Técnica",
          subtitle:
            "Son categorías y acciones específicas utilizadas por los atacantes para lograr sus objetivos en un ciberataque. Las técnicas representan las acciones específicas llevadas a cabo para alcanzar estos objetivos.",
          tacticLabel: "Táctica",
          tacticPlaceholder: "Seleccione una Táctica",
          techniqueIdLabel: "Técnica ID",
          techniqueIdPlaceholder: "Seleccione la Técnica ID",
          techniqueNameLabel: "Nombre de la Técnica"
        },
        executors: {
          title: "Ejecutores",
          subtitle:
            "Para cada plataforma existe una lista de ejecutores. En la implantación estándar de Sandcat, las plataformas Darwin y Linux pueden utilizar sh y Windows puede utilizar psh (PowerShell) o cmd (símbolo del sistema). Cada bloque de plataforma consta de: command; payload; uploads; cleanup; parsers; requirements; e timeout.",
          platformLabel: "Plataforma",
          parserLabel: "Parser",
          parserLogLabel: "Parser Log",
          parserLogPlaceholder: "Seleccione una opción",
          parserSourceLabel: "Parser Source",
          parserPlaceholder:
            "Introduzca los valores separados por comas. Ejemplo: host.screenshot.png,host.chrome.bookmark_title,parser.teste",
          prerequisiteLabel: "Requisitos previos del sistema operativo",
          notPrerequisiteLabel:
            "No hay requisitos previos del sistema operativo",
          prerequisiteLabelCommand: "Requisitos previos del comando",
          notPrerequisiteLabelCommand: "No hay requisitos previos de comando",
          prerequisitePlaceholder:
            "Escribe lo que requiere tu Habilidad para funcionar",
          requiredPrivilegeLabel: "Requiere Privilegio",
          executeLabel: "Ejecutor",
          notExecuteLabel: "No hay albacea",
          payloadLabel: "Payload",
          notPayloadLabel: "No hay payload",
          addPayload: "Añadir Payload",
          commandLabel: "Comando",
          notCommandLabel: "No hay comando",
          commandPlaceholder: "Comando",
          cleanupCommandLabel: "Comando Cleanup",
          cleanupCommandPlaceholder: "Comando Cleanup",
          addCleanupCommandButton: "Añadir Comando Cleanup",
          timeoutLabel: "Tiempo de Espera"
        }
      },
      modal: {
        title: "Guardar Habilidad",
        text: "¿Estás seguro de que quieres guardar esta Habilidad?"
      }
    },
    abilityOfficial: "Oficial",
    abilityCreated: "Creado",
    requesterProfileTitle: "Perfil del solicitante",
    requesterProfileDescription:
      "Aquí se registra el perfil del solicitante para determinar el modo de acceso que se está creando, es decir, a qué características de RaidStorm puede tener acceso este perfil.",
    creatorName: "Nombre del creador",
    creatorProfile: "Perfil del creador",
    creatorObjective: "Objetivo",
    requiredPrivilegeUser: "Usuario",
    requiredPrivilegeElevated: "Elevado"
  }
}
